import ReducerCreator from '../registerReducer';
import { buildStoreItem, copyStoreItem } from '../storeItemBuilder';
import * as APPROVALSETTINGS from './approvalSettings.constants';
import { ApprovalSettings } from '../../models';
import { StoreItem } from '../Store';
import { APPLICATION_DISCONNECTED } from '../constants.index';

const r = new ReducerCreator<ApprovalSettings>().register<string>(APPLICATION_DISCONNECTED, (state, payload) => {
    return new StoreItem<ApprovalSettings>();
})
    .register<void>(APPROVALSETTINGS.APPROVAL_SETTINGS_LOAD, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        newState.isLoading = true;
        newState.isLoaded = false;
        return newState;
    })
    .register<ApprovalSettings[]>(APPROVALSETTINGS.APPROVAL_SETTINGS_LOAD_SUCCESS, (state, payload) => {
        return buildStoreItem(payload);
    })
    .register<void>(APPROVALSETTINGS.APPROVAL_SETTINGS_ADD, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        newState.isLoading = true;
        newState.isLoaded = false;
        return newState;
    })
    .register<ApprovalSettings[]>(APPROVALSETTINGS.APPROVAL_SETTINGS_ADD_SUCCESS, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        payload.forEach(p => {
            newState.dictionary[p.guid] = p;
        });
        return newState;
    })
    .register<void>(APPROVALSETTINGS.APPROVAL_SETTINGS_UPDATE, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        newState.isLoading = true;
        newState.isLoaded = false;
        return newState;
    })
    .register<ApprovalSettings[]>(APPROVALSETTINGS.APPROVAL_SETTINGS_UPDATE_SUCCESS, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        payload.forEach(p => {
            newState.dictionary[p.guid] = p;
        });
        return newState;
    })
    .register<void>(APPROVALSETTINGS.APPROVAL_SETTINGS_DELETE, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        newState.isLoading = true;
        newState.isLoaded = false;
        return newState;
    })
    .register<ApprovalSettings[]>(APPROVALSETTINGS.APPROVAL_SETTINGS_DELETE_SUCCESS, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        payload.forEach(p => {
            delete (newState.dictionary[p.guid]);
        });
        return newState;
    });

export function approvalSettingsReducer(state: StoreItem<ApprovalSettings> = new StoreItem<ApprovalSettings>(), action: { type: string, payload: any }) {
    return r.reduce(state, action);
}
